import Managers from './managers';
import Reports from './reports';

export default {
  Managers,
  Reports,
};
